import React from 'react'
import PropTypes from 'prop-types'

import { Grid } from '@material-ui/core'

import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'

import ScribbleArrowMobile from 'images/ecom/brand/scribble-green.svg'
import ScribbleArrow from 'images/ecom/brand/scribble-yellow.svg'

import { Body, CtaButton, CtaRow, Images, Photo, Scribble, Section, Title } from './BeforeAfterSection.style'
import { MOBILE_IMAGE_RATIO } from './Keepsakes.constants'
import Phrases from './Phrases'

const IMAGE_RATIO = 573 / 400

const BeforeAfterSection = ({ title, body, before, after, cta, ...rest }) => {
  const isMobile = useMobileBreakpoint()

  return (
    <Section
      title={
        <Title variant='h2' align='center'>
          <Phrases text={title} />
        </Title>
      }
      subtitle={<Body variant='body1'>{body}</Body>}
      {...rest}
    >
      <Images>
        <Grid container spacing={isMobile ? 3 : 6}>
          <Grid xs={12} md={6} item>
            <Photo ratio={isMobile ? MOBILE_IMAGE_RATIO : IMAGE_RATIO} src={before.image} alt={before.alt} />
          </Grid>
          <Grid xs={12} md={6} item>
            <Photo ratio={isMobile ? MOBILE_IMAGE_RATIO : IMAGE_RATIO} src={after.image} alt={after.alt} />
          </Grid>
        </Grid>
        <Scribble src={isMobile ? ScribbleArrowMobile : ScribbleArrow} alt='' />
      </Images>
      <CtaRow>
        <CtaButton
          color='primary'
          href={cta.href}
          size='large'
          variant='outlined'
          trackerEvent={cta.trackerEvent}
          trackerOptions={{ section: cta.section }}
        >
          {cta.label}
        </CtaButton>
      </CtaRow>
    </Section>
  )
}

const imageShape = PropTypes.shape({
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
})

BeforeAfterSection.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  before: imageShape.isRequired,
  after: imageShape.isRequired,
  cta: PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    trackerEvent: PropTypes.string.isRequired,
    section: PropTypes.string.isRequired,
  }).isRequired,
}

export default BeforeAfterSection
